import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, Icon, HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const ExperiencedSchedule = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading size="2xl" fontWeight="900" color="brand.800">
              {data.title}
            </Heading>
            <Text fontSize="lg" color="brand.500" maxW="2xl">
              {data.description}
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8} w="full">
            {data.items.map((item, index) => (
              <MotionBox
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Box
                  p={8}
                  bg="brand.50"
                  borderRadius="2xl"
                  textAlign="center"
                  h="full"
                  _hover={{
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(16,185,129,0.2)',
                    bg: 'white',
                  }}
                  transition="all 0.3s"
                >
                  <VStack spacing={4}>
                    <Icon as={item.icon} boxSize={12} color="accent.green" />
                    <Heading size="md" color="brand.700">
                      {item.title}
                    </Heading>
                    <Text color="brand.500" fontSize="sm">
                      {item.desc}
                    </Text>
                  </VStack>
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ExperiencedSchedule;